import * as datastore from '@/datastore'

export interface PantryItem extends datastore.Reference {
	name: string
	notes: string
}

export const defaultPantryItem: Readonly<PantryItem> = {
	$id: '',
	name: '',
	notes: '',
}
